import { useState } from 'react';
import { ThemeProvider } from './context/ThemeContext';
import ComicMenu from './components/ComicMenu';
import ComicGame from './components/ComicGame';
import { Analytics } from '@vercel/analytics/react';
import './styles/App.css';

function App() {
  const [gameStarted, setGameStarted] = useState(false);
  const [isInitializing, setIsInitializing] = useState(false);

  const handleStartGame = () => {
    setIsInitializing(true);
    setGameStarted(true);
  };

  const handleGameReady = () => {
    setIsInitializing(false);
  };

  const handleReturnToMenu = () => {
    setGameStarted(false);
    setIsInitializing(false);
  };

  return (
    <ThemeProvider>
      <div className="app">
        {!gameStarted ? (
          <ComicMenu onStartGame={handleStartGame} />
        ) : (
          <ComicGame
            isInitializing={isInitializing}
            onGameReady={handleGameReady}
            onReturnToMenu={handleReturnToMenu}
          />
        )}
        <Analytics />
      </div>
    </ThemeProvider>
  );
}

export default App;
